// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;Lord, I love the house of your habitation&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the place where your glory abides.<br> </p> </div></div>";
// Exports
module.exports = code;